import React from "react";
//images
import heroimg from "../../../assets/images/pages/training.jpg";

// components
import HeroSection from "../../../components/ui/Cards/Hero";

// state
import { get_trainings } from "../../../service/api/training";
import { useAppDispatch, useAppSelector } from "../../../store";
// import CustomHeader from "../../../components/ui/CustomHeader/CustomHeader";

const Training = () => {
  const dispatch = useAppDispatch();
  const current_page = useAppSelector(({ training }) => training.current_page);

  const onLoad = React.useCallback(() => {
    get_trainings(dispatch, current_page);
  }, [current_page, dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="w-full">
      <HeroSection
        title="Corporate Setup Trainings"
        titleColor="text-primary-900"
        description="We offer a wide range of training programs to help you and your team stay ahead in the ever-evolving corporate landscape. Whether you're looking to enhance your skills, improve team collaboration, or stay updated with the latest industry trends, we have the right training program for you. "
        descriptionColor="text-primary-900"
        buttonText="Learn More"
        buttonLink="https://training.corporate-setup.com/courses/"
        imageSrc={heroimg}
        imageAlt="Hero Section"
        imagePosition="left"
        imagePositionBgColor="bg-white/30"
        imageRotation="-rotate-3"
        background="bg-customyellow"
        buttonbg="bg-primary-900"
        buttonTextColor="text-white"
        buttonHoverBg="bg-primary-800"
        paddingtop="pt-20"
      />
    </div>
  );
};

export default Training;
